import React, { useState } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import DateRangeDropdown from "../../components/performance/Filter";
import { Link } from 'react-router-dom';

import dollarIcon from '../../../../assets/images/performance/doller-icon.svg';
import personIcon from '../../../../assets/images/performance/person-star.svg';
import checkIcon from '../../../../assets/images/performance/eye-check.svg';
import clockPlus from '../../../../assets/images/performance/clock-plus.svg';
import chartIcon from '../../../../assets/images/performance/chart.svg'

ChartJS.register(ArcElement, Tooltip, Legend);

const MarketingChannel = () => {
  const [dateRange, setDateRange] = useState("12_months");
  const [excludedChannels, setExcludedChannels] = useState([]);

  const handleDateRangeChange = (range) => {
    setDateRange(range);
  };

  const channelData = [
    {
      name: "Event Calendars",
      slug: "event_calendars",
      campaigns: 120,
      roi: "6.03x",
      sales: 18897,
      visitors: 4301,
      views: 225216,
      hoursSaved: 328,
      color: "#9333ea",
      spend: 97.6
    },
    {
      name: "Partner Email Blast",
      slug: "email_list",
      campaigns: 85,
      roi: "5.10x",
      sales: 14230,
      visitors: 3900,
      views: 184000,
      hoursSaved: 290,
      color: "#2dd4bf",
      spend: 78.3
    },
    {
      name: "Featured Placements",
      slug: "featured_placements",
      campaigns: 60,
      roi: "4.75x",
      sales: 12050,
      visitors: 3100,
      views: 162300,
      hoursSaved: 245,
      color: "#ec4899",
      spend: 64.7
    },
    {
      name: "Press Release AI",
      slug: "press_release_ai",
      campaigns: 33,
      roi: "3.90x",
      sales: 10500,
      visitors: 2700,
      views: 132000,
      hoursSaved: 190,
      color: "#6366f1",
      spend: 49.3
    },
    {
      name: "Social Media",
      campaigns: 20,
      roi: "3.20x",
      sales: 9200,
      visitors: 2200,
      views: 98000,
      hoursSaved: 155,
      color: "#f59e0b",
      spend: 36.8
    },
    {
      name: "Meta Ads",
      campaigns: 10,
      roi: "2.80x",
      sales: 7400,
      visitors: 1700,
      views: 71000,
      hoursSaved: 120,
      color: "#10b981",
      spend: 22.4
    },
    {
      name: "Event Email Platform",
      campaigns: 5,
      roi: "2.10x",
      sales: 5200,
      visitors: 1300,
      views: 54000,
      hoursSaved: 90,
      color: "#3b82f6",
      spend: 14.7
    },
    {
      name: "Display Ads AI",
      campaigns: 3,
      roi: "1.75x",
      sales: 4300,
      visitors: 1100,
      views: 42000,
      hoursSaved: 65,
      color: "#ef4444",
      spend: 9.8
    },
    {
      name: "Influencer AI",
      campaigns: 2,
      roi: "1.45x",
      sales: 3100,
      visitors: 900,
      views: 32000,
      hoursSaved: 50,
      color: "#8b5cf6",
      spend: 6.2
    },
    {
      name: "Podcast Ads AI",
      campaigns: 1,
      roi: "1.20x",
      sales: 1900,
      visitors: 600,
      views: 21000,
      hoursSaved: 35,
      color: "#14b8a6",
      spend: 3.1
    }
  ];

  const handleLabelClick = (name) => {
    setExcludedChannels(prev =>
      prev.includes(name) ? prev.filter(n => n !== name) : [...prev, name]
    );
  };

  const filteredData = channelData.filter(channel => !excludedChannels.includes(channel.name));

  const chartData = {
    labels: filteredData.map(channel => channel.name),
    datasets: [
      {
        data: filteredData.map(channel => channel.spend),
        backgroundColor: filteredData.map(channel => channel.color),
        borderWidth: 0,
        cutout: '50%'
      }
    ]
  };

  const chartOptions = {
    responsive: true,
    aspectRatio: 1.82,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.label}: ${context.raw}% of spend`;
          }
        }
      }
    },
    maintainAspectRatio: true
  };

  return (
    <div>
      <div className="performance__heading mb-4">
        <h2>Marketing Channels</h2>
        <DateRangeDropdown
          onRangeChange={handleDateRangeChange}
          selectedRange={dateRange}
        />
      </div>

      <div className="row marketing_channel">
        <div className="col-lg-8 pr-lg-0" >
          <div className="card marketing_channel__table h-100">
            <div className="table-responsive">
              <table className="table bg-white">
                <thead>
                  <tr className="text-muted small" style={{backgroundColor: "#ffffff", position: "sticky", top: 0, zIndex: 1}}>
                    <th className="border-0 events-th">Channel Name</th>
                    <th className="border-0 events-th">Estimated ROI</th>
                    <th className="border-0 events-th">Estimated Sales</th>
                    <th className="border-0 events-th">Ticket Page Visitors</th>
                    <th className="border-0 events-th">Estimated Views</th>
                    <th className="border-0 events-th">Hours Saved</th>
                    <th className="border-0 events-th">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {channelData.map((channel, index) => (
                    <tr key={`${channel.name}-${index}`}>
                      <td className="pl-4">
                        <h6>
                          <div className='v-line' style={{ backgroundColor: channel.color }}></div>
                          {channel.name}
                        </h6>
                        <div className="desc">
                          {channel.campaigns} Campaign{channel.campaigns !== 1 ? 's' : ''}
                        </div>
                      </td>
                      <td className="border-top events-tr">
                          <img src={chartIcon} className="pr-1" alt="chart icon" />
                          {channel.roi}
                      </td>
                      <td className="border-top events-tr">
                          <img src={dollarIcon} className="pr-1" alt="event" />
                          {channel.sales}
                      </td>
                      <td className="border-top events-tr">
                          <img src={personIcon} className="pr-1" alt="event" />
                          {channel.visitors}
                      </td>
                      <td className="border-top events-tr">
                          <img src={checkIcon} className="pr-1" alt="event" />
                          {channel.views}
                      </td>
                      <td className="border-top events-tr">
                          <img src={clockPlus} className="pr-1" alt="event" />
                          {channel.hoursSaved}
                      </td>
                      <td className="border-top events-tr">
                        {index > 3 ? (
                          <div className='coming-soon-badge' data-toggle="tooltip" data-placement="top" title="Coming Soon">Coming Soon</div>
                          ): (
                          <Link to={`/marketing/${channel.slug}`} className="create-btn">
                            Create <i className="fa fa-arrow-right"></i>
                          </Link>
                        )}

                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="col-lg-4 mt-3 mt-lg-0 pl-lg-2 " >
          <div className="card marketing_channel__usage h-100">
            <h5 className='mb-3'>Usage By Channel</h5>
            <Doughnut data={chartData} options={chartOptions} />

            <div className="mt-4">
              {channelData.reduce((rows, channel, index) => {
                if (index % 2 === 0) rows.push([channel]);
                else rows[rows.length - 1].push(channel);
                return rows;
              }, []).map((row, rowIndex) => (
                <div className="row mb-md-3" key={rowIndex}>
                  {row.map((channel, colIndex) => (
                    <div
                      key={colIndex}
                      className="col-12 col-sm-6 channel-dot-container"
                      onClick={() => handleLabelClick(channel.name)}
                    >
                      <div className="channel-dot" style={{ backgroundColor: channel.color}}></div>
                      <div>
                        <h6 style={{ color: channel.color }}>{channel.name}</h6>
                        <div className="desc">{channel.spend}% of spend</div>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketingChannel;
